import { defineMessages } from 'react-intl';

export default defineMessages({
    newPassword: {
        id: 'app.components.bulkPasswordChange.newPassword',
        defaultMessage: 'Enter New Password'
    }
});



// WEBPACK FOOTER //
// ./app/components/bulk-password-change/messages.js